// Find-usages API client.
//
// Backend signature:
//   POST /api/connections/{id}/find-usages
//   body: { token, mode: 'identifier'|'qualified'|'exact', kinds?: string[] }
//
// Response:
//   { matches: Match[], skipped?: Skipped[] }
//
// where each Match carries:
//   - kind: 'saved' | 'scrap' | 'history' | 'form' | 'routine' | 'trigger' | 'view' | 'event'
//   - name, subname?, schema?, field?
//   - snippet, matchStart, matchEnd  (offsets into the snippet)
//   - sql       (the full body — for "Open in tab")
//   - database?, connectionId?, createdAt?
import { api } from './api.js';

export async function findUsages(connectionId, { token, mode = 'identifier', kinds = [], database = '' }) {
  return api.post(`/api/connections/${connectionId}/find-usages`, { token, mode, kinds, database });
}

// Friendly labels for each source kind. Used by the modal's grouping and the
// "Open in tab" / "Open routine" affordance picker.
export const KIND_LABELS = {
  saved:   { label: 'Saved query',  icon: '★', plural: 'Saved queries' },
  scrap:   { label: 'Scrap',        icon: '📋', plural: 'Scraps' },
  history: { label: 'History',      icon: '⏱', plural: 'Query history' },
  form:    { label: 'Form',         icon: '📝', plural: 'Forms' },
  routine: { label: 'Routine',      icon: 'ƒ', plural: 'Routines' },
  trigger: { label: 'Trigger',      icon: '⚡', plural: 'Triggers' },
  view:    { label: 'View',         icon: '👁', plural: 'Views' },
  event:   { label: 'Event',        icon: '🕐', plural: 'Events' },
};

// Identifier under the cursor — given an editor text + a cursor position,
// returns the bare identifier the cursor is inside / adjacent to (or empty).
// Honours backticks. Used by the right-click "Find usages of …" affordance.
export function identAt(text, pos) {
  if (!text) return '';
  const isId = (c) => c === '_' || c === '$' ||
    (c >= '0' && c <= '9') || (c >= 'A' && c <= 'Z') || (c >= 'a' && c <= 'z');
  // Walk left to the start of the ident.
  let start = pos;
  while (start > 0 && isId(text[start - 1])) start--;
  // Walk right to the end.
  let end = pos;
  while (end < text.length && isId(text[end])) end++;
  if (start === end) return '';
  return text.slice(start, end);
}
